<template>
    <ContentLayout>
        <PageTitle :withBackButton="true" />

        <Card class="mt-4">
            <template #header>
                <div class="pl-5 pt-4 font-medium text-[16px]">
                    Vartotojo informacija
                </div>
            </template>
            <template #content>
                <div>
                    <div><strong>Vardas:</strong> {{ user.first_name }}</div>
                    <div><strong>Pavardė:</strong> {{ user.last_name }}</div>
                    <div><strong>El. paštas:</strong> {{ user.email }}</div>
                    <div><strong>Rolė:</strong> {{ user.role }}</div>
                </div>
            </template>
        </Card>

        <Card class="mt-4" :pt="{
            body: () => ({
                class: [
                    '!p-0 !rounded-b-lg'
                ]
            })
        }">
            <template #header>
                <div class="pl-5 pt-4 font-medium text-[16px] mb-4">
                    Kontaktai
                </div>
            </template>
            <template #content>
                <DataTable :paginator="isPaginationEnabled"
                           :rows="perPage"
                           :totalRecords="totalContactsCount"
                           :value="contactsList"
                           :lazy="true"
                           :loading="isTableLoading"
                           tableStyle="min-width: 50rem"
                           :pt="{
                               tableContainer: () => ({
                                   class: [
                                       '!rounded-xl'
                                   ]
                               })
                           }"
                           @page="onPageChange"
                           size="small"
                >
                    <Column field="first_name" header="Vardas"></Column>
                    <Column field="last_name" header="Pavardė"></Column>
                    <Column field="email" header="El. paštas"></Column>
                    <Column field="phone" header="Tel. nr."></Column>
                    <Column field="region" header="Regionas"></Column>
                    <Column field="budget" header="Biudžetas">
                        <template #body="{ data }">
                            &euro;{{ data.budget }}
                        </template>
                    </Column>
                    <Column field="created_at" header="Sukurta"></Column>
                    <Column>
                        <template #body="{ data }">
                            <div class="flex flex-row gap-2">
                                <Button @click="viewContact(data.id)" class="" severity="secondary" rounded size="small">
                                    Peržiūrėti
                                </Button>
                            </div>
                        </template>
                    </Column>
                    <template #empty>Paskyrų nerasta</template>
                </DataTable>
            </template>
        </Card>
    </ContentLayout>
</template>

<script setup lang="ts">
    import { ref, onMounted, watch } from 'vue'
    import { useRouter } from 'vue-router';
    import { apiRequest } from '@/services/axios';

    import Button from 'primevue/button';
    import Card from 'primevue/card';
    import DataTable from 'primevue/datatable'
    import Column from 'primevue/column'

    import ContentLayout from '@/components/layouts/Content.vue';
    import PageTitle from '@/components/navigation/PageTitle.vue';

    // Refs and variables
    const user = ref<any>({
        id: 0,
        first_name: '',
        last_name: '',
        email: '',
        role: ''
    });
    const contactsList = ref<Array<object>>([]);
    const totalContactsCount = ref<number>(0);
    const perPage = ref<number>(0)
    const isTableLoading = ref<boolean>(false);
    const isPaginationEnabled = ref<boolean>(false);
    const router = useRouter();
    const currentPage = ref<number>(1);

    // Hooks
    onMounted(() => {
        getUser();
        getContacts();
    });

    // Methods
    async function getUser() {
        const response = await apiRequest(
            'get',
            '/users/' + router.currentRoute.value.params.id
        );

        user.value = response.data.data.user;
    }

    async function getContacts(page: number = 1)
    {
        isTableLoading.value = true;
        currentPage.value = page;

        const response = await apiRequest(
            'get',
            '/users/' + router.currentRoute.value.params.id + '/contacts',
            {},
            {
                params: {
                    page: page
                }
            }
        );

        contactsList.value = response.data.data.contacts.data;
        totalContactsCount.value = response.data.data.contacts.total;
        perPage.value = response.data.data.contacts.per_page;

        if (response.data.data.contacts.last_page > 1) {
            isPaginationEnabled.value = true;
        }

        isTableLoading.value = false;
    }

    function viewContact(contactId: number) {
        router.push({ name: 'contact', params: { id: contactId }})
    }

    // Events
    const onPageChange = (event: any) => {
        currentPage.value = parseInt(event.page + 1);

        getContacts(currentPage.value)
    };
</script>